import React, { useState } from "react";
import "./account-settings-header.styles.scss";

import ReactTooltip from "react-tooltip";

import { CustomButton } from "../custom-button/custome-button.component";
import { withRouter } from "react-router-dom";
import { ToolTip } from "../tool-tip/tool-tip.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const AccountSettingHeader = withRouter(
  ({ headerTitle, pageRoute, history, displayButton, toolTip }) => {
    return (
      <div className="setting-header-wrapper">
        <div className="setting-header-container">
          <p>
            {headerTitle}
            {toolTip ? (
              <i
                className="ms-2"
                data-tip="To uphold the integrity of the marketplace, <br> all sellers must have a valid payout <br> method on file."
              >
                <FontAwesomeIcon icon={["fa", "question-circle"]} />
                <ReactTooltip
                  multiline={true}
                  place="top"
                  type="light"
                  effect="solid"
                  backgroundColor="white"
                  textColor="black"
                  className="data-class"
                  border={true}
                  borderColor="black"
                />
              </i>
            ) : null}
          </p>
          {displayButton ? null : (
            <CustomButton
              onClick={() => {
                window.localStorage.setItem("cords", null);
                if (
                  pageRoute === "shippingInfo/1" ||
                  pageRoute === "shippingInfo/0" ||
                  pageRoute === "payoutInfo"
                ) {
                  window.localStorage.setItem("cords", null);
                  history.push({
                    pathname: pageRoute,
                    state: {
                      historySetting: true,
                    },
                  });
                } else {
                  history.push(`${pageRoute}`);
                }
              }}
              size="smallInverted"
            >
              Edit
            </CustomButton>
          )}
        </div>
        <hr></hr>
      </div>
    );
  }
);
